export const shouldAddTracking = (slug?: string) => {
  if (!slug) {
    return false
  }
  const slugsToTrack = ['pensions-and-retirement']

  return slugsToTrack.includes(slug)
}

export function extractContentIdFromUrl(href?: string | null): string | null {
  if (!href || typeof href !== 'string') {
    return null
  }

  // Match any alphanumeric segment that contains at least one number
  // This will match codes with mixed case, lowercase+numbers, uppercase+numbers, etc.
  const regex = /-([A-Za-z]*\d[A-Za-z\d]*)\/?(?=$|[?#])/
  const codeMatch = regex.exec(href)

  return codeMatch ? codeMatch[1] : null
}
